"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var Frame = /** @class */ (function (_super) {
    tslib_1.__extends(Frame, _super);
    function Frame(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLoad = function () {
            _this.forceUpdate();
        };
        _this.mounted = false;
        _this.setInitialContent = false;
        return _this;
    }
    Frame.prototype.componentDidMount = function () {
        this.mounted = true;
        var doc = this.getDoc();
        if (doc && doc.readyState === 'complete') {
            this.forceUpdate();
        }
        else {
            this.node.addEventListener('load', this.handleLoad);
        }
    };
    Frame.prototype.componentWillUnmount = function () {
        this.mounted = false;
        this.node.removeEventListener('load', this.handleLoad);
    };
    Frame.prototype.getDoc = function () {
        return this.node.contentDocument; // eslint-disable-line
    };
    Frame.prototype.getMountTarget = function () {
        var doc = this.getDoc();
        return doc.body;
    };
    Frame.prototype.renderFrameContents = function () {
        if (!this.mounted) {
            return null;
        }
        var doc = this.getDoc();
        var initialRender = !this.setInitialContent;
        var contents = this.props.children;
        if (initialRender) {
            doc.open('text/html', 'replace');
            doc.write('<!DOCTYPE html><html><head></head><body></body></html>');
            doc.close();
            this.setInitialContent = true;
            doc.head.innerHTML = this.props.head;
        }
        var mountTarget = this.getMountTarget();
        return [react_dom_1.default.createPortal(contents, mountTarget)];
    };
    Frame.prototype.render = function () {
        var _this = this;
        var props = tslib_1.__assign(tslib_1.__assign({}, this.props), { children: undefined });
        return (react_1.default.createElement("iframe", tslib_1.__assign({}, props, { title: this.props.id, ref: function (node) {
                _this.node = node;
            } }), this.renderFrameContents()));
    };
    return Frame;
}(react_1.Component));
exports.default = Frame;
//# sourceMappingURL=Frame.js.map